var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"empty-card"},'div',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"size":"64","color":"primary"}},[_vm._v(_vm._s(_vm.icons.mdiPlus))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }